import { defineStore } from 'pinia'
import { useCacheStore } from '~/store/cache'
import { useCmsFetch } from '~/composables/craft-fetch'

export const useCtaStore = defineStore('cta', () => {
  const cmsFetch = useCmsFetch()

  async function fetchCta(ctaCategory: string) {
    if (!ctaCategory) return []

    const cacheStore = useCacheStore()
    const key = `cta;${ctaCategory}`
    const ttl = 60

    const fetcher = async () => {
      return await cmsFetch(`/api/cta/${ctaCategory}.json`, { notFoundStrategy: 'ignore' })
    }

    return await cacheStore.fetch({ key, ttl, fetcher, fallback: [] })
  }

  return { fetch: fetchCta }
})
